import React from 'react'
import { Col,Button,Input,} from 'reactstrap';
import { Dialog } from 'primereact/dialog';


export const ModalCreateSample = (props) => {

    // ? CONFIGURATION 
    const {modalSample,toggleSample,handleText,saveCreateSample} = props;

    return (
        <Dialog 
            header="Crear nueva muestra"
            visible={modalSample}
            onHide={toggleSample}
            headerStyle={{
                    backgroundColor: '#0d3b59',
                    color: 'white',
                    fontWeight: 'bold',
                }}
            pt={{
                    header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
            className="pt-0 custom-dialog-img-sample"
            footer={
                <div>
                    <Button onClick={() => saveCreateSample()} color='secondary' type="button">{"Aceptar"}</Button>
                </div>
            }
        >
            <Col sm="12" className='pt-2' >
                <label className='label-dashboard' style={{color:"#565a5efc", fontWeight: "bold", fontSize:"15px"}}  >Nombre de la muestra</label>
                <Input className="form-control" onChange={(e) => handleText(e.target.value)}></Input>
            </Col>            
        </Dialog>
    )
}